import React from 'react';
import {
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';

const ConfirmAlert = (props) => {
  return (
    <Dialog
      open={props.show}
      onClose={() => props.onDiscarded(props.payload)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.onConfirmed(props.payload)} color={props.danger ? 'secondary' : 'primary'} autoFocus>
          Yes
        </Button>
        <Button onClick={() => props.onDiscarded(props.payload)} color={props.danger ? 'primary' : 'secondary'}>
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmAlert;
